import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeDatatable()
    document.addEventListener("turbo:before-cache", this.destroyDatatable.bind(this))
  }

  disconnect() {
    this.destroyDatatable()
    document.removeEventListener("turbo:before-cache", this.destroyDatatable.bind(this))
  }

  initializeDatatable() {
    const dt_basic_table = $(this.element.querySelector('.datatables-basic-export-desktop'))

    // Check if DataTables is already initialized and destroy if yes
    if ($.fn.DataTable.isDataTable(dt_basic_table)) {
      dt_basic_table.DataTable().destroy()
    }

    if (dt_basic_table.length) {
      const title = dt_basic_table.data('title')
      const footer_text = dt_basic_table.data('footer')
      var now = new Date()
      var jsDate = now.getDate() + ' ' + now.toLocaleString('fr-FR', { month: 'long' }) + ' ' + now.getFullYear()
      const dt_basic = dt_basic_table.DataTable({
        order: [[0, 'desc']],
        dom: 'Bfrtip',
        displayLength: 100,
        lengthMenu: [25, 50, 75, 100],
        buttons: [
          {
            extend: 'print',
            text: '<i class="fal fa-print"></i><br />Imprimer',
            className: 'buttonToLink text-green-dark-background text-ft-14 text-weight-400',
            exportOptions: { columns: '*' },
            customize: function (win) {
              $(win.document.body).find('h1').text('Export d’observations du ' + jsDate + ' - ' + title);
              $(win.document.body).find('table').after(footer_text);
            }
          }
        ],
        responsive: {
          details: {
            display: $.fn.dataTable.Responsive.display.modal({
              header: function (row) {
                var data = row.data();
                return 'Details of ' + data['full_name'];
              }
            }),
            type: 'column',
            renderer: function (api, rowIdx, columns) {
              var data = $.map(columns, function (col, i) {
                return col.title !== '' // ? Do not show row in modal popup if title is blank (for check box)
                  ? '<tr data-dt-row="' +
                  col.rowIdx +
                  '" data-dt-column="' +
                  col.columnIndex +
                  '">' +
                  '<td>' +
                  col.title +
                  ':' +
                  '</td> ' +
                  '<td>' +
                  col.data +
                  '</td>' +
                  '</tr>'
                  : '';
              }).join('');

              return data ? $('<table class="table"/>').append('<tbody>' + data + '</tbody>') : false;
            }
          }
        },
        "bFilter": false,
        "bInfo": false,
        "lengthChange": false,
        "paging": false,
        "ordering": false,
        "info": false,
        ...window.datatablesDefaults
      });
    }
  }

  destroyDatatable() {
    const dt_basic_table = $(this.element.querySelector('.datatables-basic'))
    if ($.fn.DataTable.isDataTable(dt_basic_table)) {
      dt_basic_table.DataTable().destroy()
    }
  }
}
